import React, { useState } from "react";
import styles from "./BusinessesforSale.module.css";
import Footer from "../Footer/Footer";
import Nav from "../Nav/Nav";
import BusinessesforSale1 from "./BusinessesforSale1";
import useStore from "../../../Store";

const Investor_Proposal = () => {
  const direction = useStore((state) => state.direction);
  const [interestedIn, setInterestedIn] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [industriesInterested, setIndustriesInterested] = useState("");
  const [locationsInterested, setLocationsInterested] = useState("");
  const [dealSizeRange, setDealSizeRange] = useState({ min: "", max: "" });
  const [currentLocation, setCurrentLocation] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [designation, setDesignation] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [businessFactors, setBusinessFactors] = useState("");
  const [aboutCompany, setAboutCompany] = useState("");
  const [profilePicture, setProfilePicture] = useState(null);
  const [companyLogo, setCompanyLogo] = useState(null);
  const [corporateProfile, setCorporateProfile] = useState(null);
  const [proofOfBusiness, setProofOfBusiness] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [videoFile, setVideoFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showServices, setShowServices] = useState(false);

  const toggleServices = () => {
    setShowServices(!showServices);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "video/mp4") {
      setVideoFile(file);
      setErrorMessage("");
    } else {
      setErrorMessage("Please upload a valid MP4 video file.");
    }
  };

  const handleUpload = () => {
    if (videoFile) {
      setVideoFile(null);
    }
  };

  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan);
  };

  const handleTermsChange = (event) => {
    setTermsAccepted(event.target.checked);
  };

  const handleCompanyLogoChange = (event) => {
    const file = event.target.files[0];
    setCompanyLogo(file); 
  };


  const handleCorporateProfileChange = (event) => {
    const file = event.target.files[0];
    setCorporateProfile(file);
  };

  // Handler for proof of business upload
  const handleProofOfBusinessChange = (event) => {
    const file = event.target.files[0];
    setProofOfBusiness(file); 
  };

  // Handlers for InvestorForm
  const handleInterestedInChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setInterestedIn([...interestedIn, value]);
    } else {
      setInterestedIn(interestedIn.filter((item) => item !== value));
    }
  };

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleDealSizeChange = (e) => {
    const { id, value } = e.target;
    setDealSizeRange((prev) => ({
      ...prev,
      [id === "dealSizeMin" ? "min" : "max"]: value,
    }));
  };

  const handleProfilePictureChange = (e) => {
    setProfilePicture(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      interestedIn,
      selectedOption,
      industriesInterested,
      locationsInterested,
      dealSizeRange,
      currentLocation,
      companyName,
      designation,
      companyWebsite,
      businessFactors,
      aboutCompany,
      profilePicture,
    };
  };

  return (
    <div style={{ direction }}>
      <Nav />
      <div className={styles.about_container}>
        <BusinessesforSale1 />
      </div>
      <div className={styles["withAdvisor-register-container"]}>
        <div className={styles["withAdvisor-form-container"]}>
          <h2>Register Business Profile</h2>

          <div className={styles["User-personaldetails-section"]}>
            <div className={styles["User-personaldetails-section-heading"]}>
              <h3>Confidential Information</h3>
              <p>
                Please enter your own details here. Information entered here is
                not publicly displayed.
              </p>
            </div>
            <div className={styles["User-personaldetails-section-content"]}>
              <div className={styles["withAdvisor-input-group"]}>
                <label htmlFor="fullName">Your Full Name</label>
                <div className={styles["withAdvisor-input-field"]}>
                  <input type="text" id="fullName" placeholder="full name" />
                  <span className={styles["withAdvisor-icon"]}>?</span>
                </div>
                <p className={styles["withAdvisor-helper-text"]}>
                  Please enter your full name
                </p>
              </div>
              <div className={styles["withAdvisor-input-group"]}>
                <label htmlFor="email">Enter official email</label>
                <div className={styles["withAdvisor-input-field"]}>
                  <input
                    type="email"
                    id="email"
                    placeholder="example@mail.com"
                  />
                  <span className={styles["withAdvisor-icon"]}>?</span>
                </div>
              </div>
              <div className={styles["withAdvisor-input-group"]}>
                <label htmlFor="phone">Your Mobile Number</label>
                <div
                  className={`${styles["withAdvisor-input-field"]} ${styles["withAdvisor-phone-input"]}`}
                >
                  <select>
                    <option>+91</option>
                    <option>+1</option>
                    <option>+44</option>
                  </select>
                  <input type="text" id="phone" />
                  <span
                    className={`${styles["withAdvisor-icon"]} ${styles["withAdvisor-check-icon"]}`}
                  >
                    ✔
                  </span>
                </div>
                <p className={styles["withAdvisor-helper-text"]}>
                  Verify with WhatsApp
                </p>
              </div>
              <div>
                <p>
                  Display contact details to introduced members so that they can
                  contact me directly
                </p>
                <p>
                  Display company details to introduced members so that they can
                  know about my company
                </p>
                <p>
                  I have someone else who will take care of this profile (view,
                  edit and manage this profile)
                </p>
              </div>
            </div>
          </div>

          <div className={styles["User-Companydetails-section"]}>
            <div className={styles["User-personaldetails-section-heading"]}>
              <h3>Business Information</h3>
              <p>
                Information entered here is displayed publicly to match you with
                the right set of investors and buyers. Du not mention business
                name/information which can identify the business.
              </p>
            </div>
            <div className={styles["User-personaldetails-section-content"]}>
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="industriesInterested"
                >
                  You are a(n)
                </label>
                <input
                  className={styles["form-input"]}
                  type="text"
                  id="Interested"
                  value={industriesInterested}
                />
              </div>
              {/* Industries Interested In */}
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="industriesInterested"
                >
                  Select industries you are interested in:
                </label>
                <input
                  className={styles["form-input"]}
                  type="text"
                  id="industriesInterested"
                  value={industriesInterested}
                  onChange={(e) => setIndustriesInterested(e.target.value)}
                  placeholder="Select multiple industries"
                />
              </div>

              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="industriesInterested"
                >
                  When was the business established?
                </label>
                <input
                  className={styles["form-input"]}
                  type="text"
                  id="Interested"
                  value={industriesInterested}
                />
              </div>

              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="industriesInterested"
                >
                  Select business industry
                </label>
                <input
                  className={styles["form-input"]}
                  type="text"
                  id="Interested"
                  value={industriesInterested}
                />
              </div>

              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="industriesInterested"
                >
                  Where is the business located/ headquartered?
                </label>
                <input
                  className={styles["form-input"]}
                  type="text"
                  id="Interested"
                  value={industriesInterested}
                />
              </div>

              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="industriesInterested"
                >
                  How many permanent employees does the business have?
                </label>
                <input
                  className={styles["form-input"]}
                  type="text"
                  id="Interested"
                  value={industriesInterested}
                />
              </div>

              {/* Business Factors */}
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="businessFactors"
                >
                  Select business legal entity type
                </label>
                <textarea
                  className={styles["form-input"]}
                  id="businessFactors"
                  value={businessFactors}
                  onChange={(e) => setBusinessFactors(e.target.value)}
                  placeholder="Enter important factors"
                ></textarea>
              </div>

              {/* About Your Company */}
              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="aboutCompany">
                  Describe the business in a single line:
                </label>
                <textarea
                  className={styles["form-input"]}
                  id="aboutCompany"
                  value={aboutCompany}
                  onChange={(e) => setAboutCompany(e.target.value)}
                  placeholder="Provide details about your company"
                ></textarea>
              </div>

              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="aboutCompany">
                  What are the business's top-selling products and services, who
                  uses them, and how?
                </label>
                <textarea
                  className={styles["form-input"]}
                  id="aboutCompany"
                  value={aboutCompany}
                  onChange={(e) => setAboutCompany(e.target.value)}
                  placeholder="Provide details about your company"
                ></textarea>
              </div>

              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="aboutCompany">
                  Mention highlights of the business Including number of
                  clients, revenue model, promoter experience, business
                  relationships, awards, etc
                </label>
                <textarea
                  className={styles["form-input"]}
                  id="aboutCompany"
                  value={aboutCompany}
                  onChange={(e) => setAboutCompany(e.target.value)}
                  placeholder="Provide details about your company"
                ></textarea>
              </div>

              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="aboutCompany">
                  Describe your facility such as built-up area, number of
                  floors, rental/lease details
                </label>
                <textarea
                  className={styles["form-input"]}
                  id="aboutCompany"
                  value={aboutCompany}
                  onChange={(e) => setAboutCompany(e.target.value)}
                  placeholder="Provide details about your company"
                ></textarea>
              </div>

              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="aboutCompany">
                  How is the business funded presently? Mention all debts/loans
                  outstanding and the total number of shareholders/owners of the
                  business with percentage ownership.
                </label>
                <textarea
                  className={styles["form-input"]}
                  id="aboutCompany"
                  value={aboutCompany}
                  onChange={(e) => setAboutCompany(e.target.value)}
                  placeholder="Provide details about your company"
                ></textarea>
              </div>

              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="averageMonthlySales"
                >
                  At present, what is your average monthly sales?
                </label>
                <input
                  className={styles["form-input"]}
                  id="averageMonthlySales"
                  type="text"
                  placeholder="INR"
                />
              </div>

              {/* Latest Reported Yearly Sales */}
              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="yearlySales">
                  What was your latest reported yearly sales?
                </label>
                <input
                  className={styles["form-input"]}
                  id="yearlySales"
                  type="text"
                  placeholder="INR"
                />
              </div>

              {/* EBITDA / Operating Profit Margin Percentage */}
              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="ebitda">
                  What is the EBITDA / Operating Profit Margin Percentage?
                </label>
                <input
                  className={styles["form-input"]}
                  id="ebitda"
                  type="text"
                  placeholder="Enter percentage"
                />
              </div>

              {/* Tangible and Intangible Assets */}
              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="assets">
                  List all tangible and intangible assets the business owns
                </label>
                <textarea
                  className={styles["form-input"]}
                  id="assets"
                  placeholder="List assets here"
                ></textarea>
              </div>

              {/* Value of Physical Assets */}
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="physicalAssets"
                >
                  What is the value of physical assets owned by the business
                  that would be part of the transaction?
                </label>
                <input
                  className={styles["form-input"]}
                  id="physicalAssets"
                  type="text"
                  placeholder="INR"
                />
              </div>

              {/* Value of Collateral */}
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="collateralValue"
                >
                  What is the value of collateral you can provide?
                </label>
                <input
                  className={styles["form-input"]}
                  id="collateralValue"
                  type="text"
                  placeholder="INR"
                />
              </div>

              {/* Loan Amount */}
              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="loanAmount">
                  What loan amount are you seeking?
                </label>
                <input
                  className={styles["form-input"]}
                  id="loanAmount"
                  type="text"
                  placeholder="INR"
                />
              </div>

              {/* Maximum Yearly Interest */}
              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="interestRate">
                  What is the maximum yearly interest you can pay?
                </label>
                <input
                  className={styles["form-input"]}
                  id="interestRate"
                  type="text"
                  placeholder="Enter percentage"
                />
              </div>

              {/* Loan Repayment Period */}
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="repaymentYears"
                >
                  In how many years will you repay the loan?
                </label>
                <input
                  className={styles["form-input"]}
                  id="repaymentYears"
                  type="text"
                  placeholder="Enter years"
                />
              </div>

              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="assets">
                  Reason for seeking a loan
                </label>
                <textarea
                  className={styles["form-input"]}
                  id="assets"
                  placeholder="List assets here"
                ></textarea>
              </div>
              <div className={styles["terms-container"]}>
                <label>
                  <input
                    type="checkbox"
                    checked={termsAccepted}
                    onChange={handleTermsChange}
                  />
                  I'm interested in receiving quotations from Advisors /
                  Boutique Investment Banks who can manage this transaction.
                </label>
              </div>
            </div>
          </div>

          <div className={styles["document-upload-section"]}>
            <div className={styles["User-personaldetails-section-heading"]}>
              <h3>Photos, Documents & Proof</h3>
              <p>
                Photos are an important part of your profile and are publicly
                displayed. Documents help us verify and approve your profile
                faster. Documents names entered here are publicly visible but
                are accessible only to introduced members.
              </p>
            </div>
            {/* Company Logo Upload */}
            <div className={styles["User-personaldetails-section-content"]}>
              <div className={styles["form-row"]}>
                <label className={styles["form-label"]} htmlFor="companyLogo">
                  Business Photos:
                </label>
                <input
                  className={styles["form-input"]}
                  type="file"
                  id="companyLogo"
                  accept="image/*"
                  onChange={handleCompanyLogoChange}
                />
              </div>

              {/* Corporate Profile Upload */}
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="corporateProfile"
                >
                  Business Documents:
                </label>
                <input
                  className={styles["form-input"]}
                  type="file"
                  id="corporateProfile"
                  accept="image/*"
                  onChange={handleCorporateProfileChange}
                />
              </div>

              {/* Proof of Business Upload */}
              <div className={styles["form-row"]}>
                <label
                  className={styles["form-label"]}
                  htmlFor="proofOfBusiness"
                >
                  Proof of Business:
                </label>
                <input
                  className={styles["form-input"]}
                  type="file"
                  id="proofOfBusiness"
                  accept="image/*"
                  onChange={handleProofOfBusinessChange}
                />
              </div>
            </div>
          </div>

          <div className={styles["plan-selection"]}>
            <div className={styles["User-personaldetails-section-heading"]}>
              <h3>Select a Plan</h3>
              <p>For more introductions, select a plan:</p>
            </div>
            <div className={styles["User-personaldetails-section-content"]}>
              <div className={styles["plan-container"]}>
                {/* Plan Cards */}
                <div
                  className={styles["plan-card"]}
                  onClick={() => handlePlanSelect("active")}
                >
                  <div className={styles["plan-card-cost"]}>
                    <h3>Active Plan</h3>
                    <button>Know More</button>
                  </div>
                  <div>
                    <p>Rs. 7,999</p>
                  </div>
                </div>

                <div
                  className={styles["plan-card"]}
                  onClick={() => handlePlanSelect("premium")}
                >
                  <div className={styles["plan-card-cost"]}>
                    <h3>Premium Plan</h3>
                    <button>Know More</button>
                  </div>
                  <div>
                    <p>Rs. 9,999</p>
                  </div>
                </div>

                <div
                  className={styles["plan-card"]}
                  onClick={() => handlePlanSelect("yearly")}
                >
                  <div className={styles["plan-card-cost"]}>
                    <h3>Yearly Plan [ Recommended ]</h3>
                    <button>Know More</button>
                  </div>
                  <div>
                    <p>Rs. 24,999</p>
                  </div>
                </div>

                {/* Plan Features */}
                {selectedPlan && (
                  <div className={styles["plan-features"]}>
                    <h4>Plan Features:</h4>
                    <ul>
                      <li>
                        Connect with businesses which send you a proposal for
                        free
                      </li>
                      <li>
                        Access to metrics of all businesses to evaluate the
                        opportunity
                      </li>
                      <li>
                        Connect and instantly access Business Name, if business
                        has allowed
                      </li>
                      <li>
                        Connect and instantly access Contact Details, if
                        business has allowed
                      </li>
                      <li>Quick email support for your queries</li>
                      <li>Valid for a period of 1 year</li>
                    </ul>
                  </div>
                )}

                {/* Individual Services Toggle */}
                <div className={styles["individual-services"]}>
                  <div
                    onClick={toggleServices}
                    className={styles["toggle-services"]}
                  >
                    <h3>Professional Business</h3>
                    <span>{showServices ? "-" : "+"}</span>{" "}
                    {/* Toggle between + and - */}
                  </div>

                  {showServices && (
                    <div className={styles["services-list"]}>
                      <div className={styles["plan-card"]}>
                        <div className={styles["plan-card-cost"]}>
                          <h3>Hire an Account Manager</h3>
                          <button>Know More</button>
                        </div>
                        <div>
                          <p>Rs. 29,999</p>
                        </div>
                      </div>

                      <div className={styles["plan-card"]}>
                        <div className={styles["plan-card-cost"]}>
                          <h3>FastTrack Bundle</h3>
                          <button>Know More</button>
                        </div>
                        <div>
                          <p>Rs. 24,999</p>
                        </div>
                      </div>

                      <div className={styles["plan-card"]}>
                        <div className={styles["plan-card-cost"]}>
                          <h3>Unlimited Bundle</h3>
                          <button>Know More</button>
                        </div>
                        <div>
                          <p>Rs. 54,999</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className={styles["submit-button-container"]}>
                  <div className={styles["terms-container"]}>
                    <label>
                      <input
                        type="checkbox"
                        checked={termsAccepted}
                        onChange={handleTermsChange}
                      />
                      accept 1% finder's fee (payable post transaction) and
                      other terms of engagement
                    </label>
                  </div>
                  <button
                    className={styles["submit-button"]}
                    disabled={!selectedPlan || !termsAccepted}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className={styles["upload-teasers"]}>
            <h2>Upload Teasers</h2>
            <p>
              Upload "No name" Teasers of your mandates here to find interested
              buyers/investors.
            </p>
            <div className={styles["upload-container"]}>
              <input
                type="file"
                accept="video/mp4"
                onChange={handleFileChange}
                className={styles["file-input"]}
              />
              <button
                onClick={handleUpload}
                className={styles["upload-button"]}
                disabled={!videoFile}
              >
                Upload Video
              </button>
            </div>
            {errorMessage && (
              <p className={styles["error-message"]}>{errorMessage}</p>
            )}
          </div>
        </div>
        {/* FAQ Section */}
        <div className={styles["withAdvisor-faq-section"]}>
          <div>
            {/* Profile Status Section */}
            <div className={styles["withAdvisor-profile-status-section"]}>
              <h3>Your Profile Status</h3>
              <ul>
                <li className={styles["withAdvisor-completed"]}>
                  Provide Details
                </li>
                <li className={styles["withAdvisor-pending"]}>
                  Verification Call
                </li>
                <li className={styles["withAdvisor-pending"]}>Approval</li>
              </ul>
            </div>
          </div>
          <div>
            <h3>Frequently Asked Questions</h3>
            <ul>
              <li>Who can create a Member Profile?</li>
              <li>I don’t want to reveal my company name</li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Investor_Proposal;
